<template>
  <div class="cases-and-claims-summary">
    <div class="table-container" style="margin-top: 20px;">
      <el-table
        :data="list"
        row-key="id"
        v-loading="loadingSearch"
        class="dark-blue-table"
        size="mini"
        tooltip-effect="dark"
        @sort-change="handleSortChange"
        stripe
        style="width: 100%"
      >
        <el-table-column prop="caseNumber" :label="$t('casesAndClaims.caseNumber')" sortable align="center"></el-table-column>
        <el-table-column prop="statusClaim" :label="$t('casesAndClaims.status')" sortable="custom" align="center">
          <template slot-scope="scope">
            {{ formatStatus(scope.row.statusClaim) }}
          </template>
        </el-table-column>
        <el-table-column prop="isClaim" :label="$t('casesAndClaims.claim')" align="center">
          <template slot-scope="scope">
<!--            <i v-if="scope.row.statusClaim === 2" class="el-icon-check"></i>-->
          <el-tooltip v-if="scope.row.isClaim" class="item" effect="dark" :enterable="false" :content="getYesNoTooltipLabel(scope.row.isClaim)" placement="top-start">
            <i class="el-icon-success green-success"></i>
          </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="invoiceNumber" :label="$t('casesAndClaims.invoiceNumber')" sortable align="center"></el-table-column>
        <el-table-column prop="pickupDate" :label="$t('casesAndClaims.pickupDate')" sortable="custom" align="center">
            <template slot-scope="scope">
                {{ formatDate(scope.row.pickupDate) }}
            </template>
        </el-table-column>
        <el-table-column prop="dateTimeOpened" :label="$t('casesAndClaims.createdDate')" sortable="custom" align="center">
            <template slot-scope="scope">
                {{ formatDate(scope.row.dateTimeOpend) }}
            </template>
        </el-table-column>
        <el-table-column prop="subject" :label="$t('casesAndClaims.subject')" sortable="custom" align="center"></el-table-column>
        <el-table-column prop="loadNumber" :label="$t('casesAndClaims.loadNumber')" sortable="custom" align="center"></el-table-column>
        <el-table-column prop="billTo" :label="$t('casesAndClaims.billTo')" sortable="custom" align="center">
          <template slot-scope="scope">
            <el-tooltip class="item"
                          effect="dark"
                          :enterable="false"
                          :content="scope.row.billToNameNumber"
                          placement="top-start">
              <span>
                {{ scope.row.billToNameNumber }}
              </span>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- el-table-column prop="shipmentDate" :label="$t('casesAndClaims.shipmentDate')" sortable="custom" align="center">
            <template slot-scope="scope">
                {{ formatDate(scope.row.shipmentDate) }}
            </template>
        </el-table-column -->
        <el-table-column prop="shipperId" :label="$t('casesAndClaims.shipper')" sortable="custom" align="center">
          <template slot-scope="scope">
            <el-tooltip class="item"
                          effect="dark"
                          :enterable="false"
                          :content="scope.row.shipperNameNumber"
                          placement="top-start">
              <span>
                {{ scope.row.shipperNameNumber }}
              </span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="consigneeId" :label="$t('casesAndClaims.consignee')" sortable="custom" align="center">
          <template slot-scope="scope">
            <el-tooltip class="item"
                          effect="dark"
                          :enterable="false"
                          :content="scope.row.consigneeNameNumber"
                          placement="top-start">
              <span>
                {{ scope.row.consigneeNameNumber }}
              </span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="shipmentNumber" :label="$t('casesAndClaims.shipmentNumber')" sortable="custom" align="center"></el-table-column>
        <el-table-column prop="createdByUsername" :label="$t('casesAndClaims.creatorUser')" sortable="custom" align="center"></el-table-column>
        <el-table-column
            prop="internal"
            label="Internal"
            sortable="custom"
            align="center">
          <template slot-scope="scope">
            <el-tooltip v-if="scope.row.internal" class="item" effect="dark" :enterable="false" :content="getYesNoTooltipLabel(scope.row.internal)" placement="top-start">
              <i class="el-icon-success green-success"></i>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
            prop="emailSent"
            label="Email sent"
            sortable="custom"
            align="center">
          <template slot-scope="scope">
            <el-tooltip v-if="scope.row.emailSent" class="item" effect="dark" :enterable="false" :content="getYesNoTooltipLabel(scope.row.emailSent)" placement="top-start">
              <i class="el-icon-success green-success"></i>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="ownerName" :label="$t('casesAndClaims.caseOwner')" sortable="custom" align="center"></el-table-column>
        <el-table-column :label="$t('common.actions')" width="100" align="center">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="Details" placement="top">
              <detail-cases-and-claims :caseAndClaim="scope.row" :internal="scope.row.internal"/>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="Details" placement="top">
              <new-detail-cases-and-claims v-if="false" :caseAndClaim="scope.row"/>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" :content="$t('common.edit')" placement="top">
              <add-cases-and-claims :caseAndClaim="scope.row"/>
            </el-tooltip>
            <el-tooltip v-if="showEmailIcon(scope.row)" content="Send email" placement="top">
              <i class="el-icon-message header-info-dialog-value icon-action"
                 id="send-email"
                 @click="confirmSendEmail(scope.row)"
                 size="mini">
              </i>
            </el-tooltip>
<!--            <el-tooltip v-if="showPrintIcon(scope.row)" content="Print form" placement="top">-->
<!--              <i  class="el-icon-printer header-info-dialog-value icon-action" id="print-form"-->
<!--                  @click="print(scope.row.id)" size="mini"></i>-->
<!--            </el-tooltip>-->
            <el-tooltip v-if="showPrintIcon(scope.row)" content="Print form for presentation of loss and damage" placement="top">
              <print-claim-form :case-id="scope.row.id" :icon="true" :button="false"/>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-footer" v-show="total  > 0">
      <span class="el-pagination__total">
        <span class="el-pagination__title">{{ $t('casesAndClaims.totalCases') }}</span>
           {{ total }}
      </span>
      <el-pagination
          @size-change="handleSizeChange"
          :page-sizes="sizes"
          :page-size="actualFilters.rows"
          :current-page.sync="actualFilters.page"
          @current-change="handleCurrentChange"
          :total="total"
          layout="sizes, prev, pager, next, jumper">
      </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import moment from 'moment';
import constants from '@/utils/constants';
import PrintClaimForm from '@/views/customerCenter/casesAndClaims/components/printClaimForm/PrintClaimForm';
import AddCasesAndClaims from './components/addCasesAndClaims/AddCasesAndClaims';
import DetailCasesAndClaims from './components/detailCasesAndClaims/DetailCasesAndClaims';
import NewDetailCasesAndClaims from './components/detailCasesAndClaims/NewDetailCasesAndClaims';

export default {
  name: 'SearchSummary',
  components: {
    PrintClaimForm,
    NewDetailCasesAndClaims,
    AddCasesAndClaims,
    DetailCasesAndClaims
  },
  data() {
    return {
      sizes: constants.TABLES.DEFAULT_LIMIT_SIZES,
    };
  },
  computed: {
    ...mapState('casesAndClaims', ['list', 'total', 'loadingSearch', 'actualFilters'])
  },
  methods: {
    ...mapActions('casesAndClaims', ['searchList', 'sendClaimEmail']),
    print(caseId) {
      this.$store.dispatch('casesAndClaims/printForm', caseId);
    },
    showEmailIcon(row) {
      return row.emailSent === false && row.statusClaim >= 2;// Show the icon only if the email has not been sent
    },
    showPrintIcon(row) {
      return row.statusClaim >= 2;
    },
    /**
     * Shows a confirmation dialog before sending the email
     * @param {Object} row - The data from the current table row
     */
    confirmSendEmail(row) {
      const message = 'Do you want to send the email with the attachment: "FORM FOR PRESENTATION OF LOSS AND DAMAGE"?';
      const title = 'Confirm Action';

      this.$confirm(message, title, {
        confirmButtonText: 'Send',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        // If the user clicks "Send"
        this.handleSendEmail(row);
      }).catch(() => { });
    },

    /**
     * Logic to actually call the API or service
     * @param {Object} row
     */
    async handleSendEmail(row) {
      try {
        await this.sendClaimEmail(row.id);
        this.$message({
          type: 'success',
          message: 'Email sent successfully'
        });
        await this.searchList({});
      } catch (error) {
        this.$message({
          type: 'error',
          message: 'Error sending email'
        });
      }
    },
    handleSizeChange(val) {
      this.searchList({ rows: val });
    },
    getYesNoTooltipLabel(internal) {
      return internal ? constants.STATUS_BOOLEAN.yes.label : constants.STATUS_BOOLEAN.no.label;
    },
    handleCurrentChange(val) {
      this.searchList({ page: val });
    },
    handleView(row) {
      this.$emit('viewDetail', row);
    },
    formatDate(date) {
      if (!date) return '';
      return moment(date).format('MM/DD/YYYY');
    },
    formatStatus(statusValue) {
      const status = constants.CASES_AND_CLAIMS.STATUS_CLAIM.find(item => item.value === statusValue);
      return status ? status.label : '';
    },
    handleSortChange(data) {
      let order = null;
      if (data.order === 'ascending') {
        order = 'asc';
      } else if (data.order === 'descending') {
        order = 'desc';
      }
      if (order) {
        this.searchList({ orderField: data.prop, orderDirection: order });
      } else {
        this.searchList({ orderField: 'id', orderDirection: 'desc' });
      }
    }

  }
};
</script>

<style scoped>
.cases-and-claims-summary {
  padding: 20px;
}
.icon-action {
    cursor: pointer;
    font-size: 1.2em;
}
</style>
